type MediaType = 'image' | 'video' | 'audio';

type SessionTimelineSection = {
  media?: {
    _type: MediaType;
    name: string;
  };
};

type SessionTimelineSegment = {
  activity?: string;
  group: string;
  leader: string;
  name: string;
  isFlex: boolean;
  enabled: boolean;
  sections: SessionTimelineSection[];
};

type SegmentToggledEventPayload = {
  activity?: string;
  group: string;
  leader: string;
  name: string;
  isFlex: boolean;
  enabled: boolean;
  images?: string[];
  videos?: string[];
};

export function formatSegmentToggledEvent(segment: SessionTimelineSegment): SegmentToggledEventPayload {
  const getSectionMediaItemNames = (sections: SessionTimelineSection[] | undefined, mediaType: MediaType): string[] => {
    if (!sections) return [];

    return sections
      .map(section => (section.media?._type === mediaType ? section.media.name : null))
      .filter(Boolean) as string[];
  };

  return {
    activity: segment.activity,
    group: segment.group,
    leader: segment.leader,
    name: segment.name,
    isFlex: segment.isFlex,
    enabled: segment.enabled,
    images: getSectionMediaItemNames(segment.sections, 'image'),
    videos: getSectionMediaItemNames(segment.sections, 'video'),
  };
}
